import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=1c6138ef"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=1c6138ef&prod&lang=stylus&module=attr"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconTemplate: require('/var/www/malayan/web/components/global/templates/IconTemplate.vue').default,ButtonTemplate: require('/var/www/malayan/web/components/global/templates/ButtonTemplate.vue').default})
